module.exports = __webpack_public_path__ + "static/media/menu_advertisement_default.8d9021da.svg";